import React from 'react';
import { TextButton as Button } from '@oneaudi/unified-web-components';
import { VendorCtaSelectorProps } from './VendorCtaSelector';

const CoxCta = ({ ctaDetails, variant, vin }: VendorCtaSelectorProps) => {
  return (
    <Button
      variant={variant}
      // eslint-disable-next-line no-script-url
      href="javascript:void(0)"
      target="_self"
      className="cox-cta"
      data-testid="cox-accelerate"
      data-vin={vin}
    >
      {ctaDetails.coxCtaLabel}
    </Button>
  );
};

export default CoxCta;
